<template>
    <div class="row">
        <div class="col-12">
            <h6 class="fw-b">{{ $t('pages.patients.discountcodes') }}</h6>
        </div>
        <div class="col-12">
            <el-table class="mb-32" :rows="patient.payments" :structure="discountCodesStructure" :editable="false">
            </el-table>
        </div>
    </div>
</template>

<script>
import { ElTable } from '@/components/tables'

export default {
    name: 'admin-patient-personalinfo',

    components: { ElTable },

    props: {
        patient: {
            required: true
        }
    },

    data() {
        return {
            discountCodesStructure: [
                { visible: true, label: this.$t('table.codes.price'), type: 'number', key: 'price', sortable: true, prefix: '€ ', size: 'small' },
                { visible: true, label: this.$t('table.codes.weeks'), type: 'number', key: 'weeks', sortable: true, size: 'small' },
                { visible: true, label: this.$t('table.codes.code'), type: 'text', key: 'used_code', sortable: true, size: 'small' },
                { visible: true, label: this.$t('table.codes.discount_amount'), type: 'number', key: 'discount_amount', sortable: true, prefix: '€ ', size: 'small' },
                { visible: true, label: this.$t('table.codes.pattern_code'), type: 'text', key: 'pattern_code', sortable: true, size: 'small' },
            ]
        }
    }
}
</script>
